import { UserRole } from "./role-permissions";

// Check if user is in free trial period (14 days)
export const isInTrialPeriod = (freeTrialStartedAt: Date | string | null): boolean => {
  if (!freeTrialStartedAt) return false;
  
  const trialStart = new Date(freeTrialStartedAt);
  const now = new Date();
  const daysSinceStart = Math.floor((now.getTime() - trialStart.getTime()) / (1000 * 60 * 60 * 24));
  
  return daysSinceStart <= 14; // 14 days trial
};

// Check if user can create new users
export const canCreateUsers = (role: UserRole, isOnboarding: boolean = false): boolean => {
  // ADMIN and MODERATOR can always create users
  if (role === "ADMIN" || role === "MODERATOR") {
    return true;
  }
  
  // MODERATOR_FREE can only create users during onboarding
  if (role === "MODERATOR_FREE" && isOnboarding) {
    return true;
  }
  
  return false;
};

// Check if user needs to upgrade
export const needsUpgrade = (role: UserRole, freeTrialStartedAt: Date | string | null): boolean => {
  // MODERATOR_FREE always needs to upgrade eventually
  if (role === "MODERATOR_FREE") {
    // If trial has expired, definitely needs upgrade
    if (!isInTrialPeriod(freeTrialStartedAt)) {
      return true;
    }
    // Even during trial, we show upgrade prompts
    return true;
  }
  
  return false;
};

// Get days remaining in trial
export const getTrialDaysRemaining = (freeTrialStartedAt: Date | string | null): number => {
  if (!freeTrialStartedAt) return 0;
  
  const trialStart = new Date(freeTrialStartedAt);
  const now = new Date();
  const daysSinceStart = Math.floor((now.getTime() - trialStart.getTime()) / (1000 * 60 * 60 * 24));
  
  const remaining = 14 - daysSinceStart;
  return remaining > 0 ? remaining : 0;
};

// Check if trial has expired
export const isTrialExpired = (freeTrialStartedAt: Date | string | null): boolean => {
  return getTrialDaysRemaining(freeTrialStartedAt) === 0;
};